import {
  imSetToArray,
  imSetToObj,
} from '@client/shared/utils/immutableUtils/immutableUtils';
import { imSetToArrayDeep } from '@client/shared/utils/utils/utils';

export const PARTICIPANT_REDUCER_KEY = 'participantReducer';

export const SET_PARTICIPANT_POSTS_SENT_TO_ADVERTISER =
  'SET_PARTICIPANT_POSTS_SENT_TO_ADVERTISER';
export const UPDATE_PARTICIPANT_BLACKLIST = 'UPDATE_PARTICIPANT_BLACKLIST';
export const PUT_AND_HANDLE_PARTICIPANT = 'PUT_AND_HANDLE_PARTICIPANT';
export const PUT_AND_HANDLE_FORCE_ACCEPT_PARTICIPANT =
  'PUT_AND_HANDLE_FORCE_ACCEPT_PARTICIPANT';
export const SET_PARTICIPANT_ERROR = 'SET_PARTICIPANT_ERROR';
export const PUT_AND_HANDLE_ADMIN_INFO = 'PUT_AND_HANDLE_ADMIN_INFO';

/* DEFAULT CAMPAIGN STATE */
let defaultState = {
  participants: [],
};

/* REDUCER */
export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case PUT_AND_HANDLE_PARTICIPANT: {
      return {
        ...state,
        participants: imSetToArrayDeep(state.participants, action.payload, [
          'influencer',
          'id',
        ]),
      };
    }
    case UPDATE_PARTICIPANT_BLACKLIST: {
      const { influencerId, checked } = action.payload;

      const updatedParticipants = state.participants.map((participant) => {
        const influencer = participant.influencer;
        if (influencer.id === influencerId) {
          const updatedInfluencer = imSetToObj(
            influencer,
            'blacklisted',
            checked
          );
          return imSetToObj(participant, 'influencer', updatedInfluencer);
        } else {
          return participant;
        }
      });

      return {
        ...state,
        participants: updatedParticipants,
      };
    }
    case PUT_AND_HANDLE_ADMIN_INFO: {
      const indexOfParticipantToUpdate = state?.participants?.findIndex(
        (participant) =>
          participant.influencer.id === action.payload.influencer.id
      );
      if (indexOfParticipantToUpdate >= 0) {
        const updatedParticipant = imSetToObj(
          state.participants[indexOfParticipantToUpdate],
          'influencer',
          action.payload.influencer
        );
        return {
          ...state,
          participants: imSetToArray(
            state.participants,
            updatedParticipant,
            null,
            indexOfParticipantToUpdate
          ),
        };
      } else {
        return state;
      }
    }
    case SET_PARTICIPANT_POSTS_SENT_TO_ADVERTISER: {
      const { participants } = action.payload;

      const updatedParticipants = state.participants.map((participant) => {
        const updatedParticipant = participants.find((newParticipant) => {
          return newParticipant.influencer.id === participant.influencer.id;
        });
        return updatedParticipant || participant;
      });

      return {
        ...state,
        participants: updatedParticipants,
      };
    }
    case PUT_AND_HANDLE_FORCE_ACCEPT_PARTICIPANT: {
      const indexOfParticipantToUpdate = state?.participants.findIndex(
        (participant) => {
          return participant.influencer.id === action.payload.influencer.id;
        }
      );
      if (indexOfParticipantToUpdate >= 0) {
        const updatedParticipant = imSetToObj(
          state.participants[indexOfParticipantToUpdate],
          'status',
          'READY_TO_SUBMIT_DRAFT'
        );
        return {
          ...state,
          participants: imSetToArray(
            state.participants,
            updatedParticipant,
            null,
            indexOfParticipantToUpdate
          ),
        };
      } else {
        return state;
      }
    }
    case SET_PARTICIPANT_ERROR: {
      return { ...state, error: action.payload };
    }
    default:
      return state;
  }
}
